import req from "../http";

const salaryType = {
  // 取得 薪資類型
  getSalaryType(params) {
    return req("get", "/BasicInformation/SalaryType", params);
  },
};

export default salaryType;